import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { MaskedTextBox } from '@progress/kendo-react-inputs';
import type { FieldTypeDefinition, FieldRendererProps } from '../registry';

function SsnRenderer({ value, onChange, readOnly }: FieldRendererProps) {
  return (
    <MaskedTextBox
      mask="000-00-0000"
      value={typeof value === 'string' ? value : ''}
      onChange={(e) => onChange(e.value ?? '')}
      disabled={readOnly}
    />
  );
}

export const definition: FieldTypeDefinition = {
  key: 'SSN',
  label: 'SSN',
  category: 'formatted',
  icon: <FontAwesomeIcon icon={faLock} fixedWidth />,
  defaultProps: {
    label: 'Social Security Number',
    isRequired: false,
  },
  Renderer: SsnRenderer,
};
